module.exports = __webpack_public_path__ + "img/e_3_24_r.15f85547.png";